import type { InjectionKey, Ref } from "vue";

export const FORM_ITEM_INJECTION_KEY = Symbol("FORM_ITEM_INJECTION_KEY") as InjectionKey<string>;

// Edited from shadcn-vue: a field that shows its value in a unit of the admin's
// choosing (kit DurationField) provides this to reword the schema's message in
// that unit. It answers undefined for any message it does not handle.
export const FORM_MESSAGE_FORMAT = Symbol("FORM_MESSAGE_FORMAT") as InjectionKey<
  (message: string) => string | undefined
>;

// Edited from shadcn-vue: provided by kit FieldRow, read by FormControl.
export const FORM_WARNING = Symbol("FORM_WARNING") as InjectionKey<Ref<boolean>>;
